module.exports = __webpack_public_path__ + "img/icon_search_black.9c682386.svg";